export default {"src":"/_next/static/media/close.5f92137b.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};